import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreateProcessStep = ClientInferResponseBody<typeof contract.processSteps.create>;

export type CreateProcessStepDto = ClientInferRequest<typeof contract.processSteps.create>["body"];

export const createProcessStep = async ({
  payload,
}: {
  payload: CreateProcessStepDto;
}): Promise<CreateProcessStep> => {
  const response = await api.processSteps.create.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Erreur lors de l'ajout du procédé", response.status, response.body);
};
